/**
 * Package setting `license_plate_needed` may be a boolean or yes/no string
 * depending on the create/edit form vs API payload.
 */
export function isLicensePlateNeeded(value: unknown): boolean {
  return value === true || value === 'yes' || value === 'true';
}
